"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const getAvailability = (available, availableCount) => {
  return typeof availableCount === "undefined" ? available : !!availableCount;
};
var _default = exports.default = getAvailability;